import { computed } from "@vue/composition-api";
import { Location } from "vue-router";
import { User } from "@scrile/api-provider/dist/api/UserProvider";
import {
  AppointmentStatus,
  InputAppointmentSearch,
} from "@scrile/api-provider/dist/projects/scrileConnect/AppointmentProvider";
import { AppointmentTypeKind } from "@scrile/api-provider/dist/projects/scrileConnect/AppointmentTypeProvider";
import { FilterOptions } from "@/hooks/useFilter";
import { $t } from "@/lib/i18nHelpers";
import { ROLES } from "@/const";

export enum AppointmentsTabNameEnum {
  REQUESTS = "requests",
  UPCOMING_WITH_ME = "upcomingWithMe",
  MY_UPCOMING = "myUpcoming",
  PENDING = "pending",
}

export interface AppointmentsTab {
  name: AppointmentsTabNameEnum;
  title: string;
  getData: (user: User) => InputAppointmentSearch;
  to: Location;
  emptyText: string;
  filter?: FilterOptions;
}

export type AppointmentsTabsType = Record<string, AppointmentsTab>;

export const appointmentsTabs = computed<AppointmentsTabsType>(() => {
  return {
    [AppointmentsTabNameEnum.REQUESTS]: {
      name: AppointmentsTabNameEnum.REQUESTS,
      title: $t("Requests"),
      getData: user => ({ providerId: user.id, status: [AppointmentStatus.NEW] }),
      to: { name: "appointments", query: { tab: "requests" } },
      emptyText: $t("No requests yet"),
      filter: { requiredRole: [ROLES.CREATOR] },
    },
    [AppointmentsTabNameEnum.UPCOMING_WITH_ME]: {
      name: AppointmentsTabNameEnum.UPCOMING_WITH_ME,
      title: $t("Upcoming"),
      getData: user => ({
        providerId: user.id,
        status: [AppointmentStatus.APPROVED, AppointmentStatus.CANCELLED],
      }),
      to: { name: "appointments", query: { tab: "upcomingWithMe" } },
      emptyText: $t("No appointments yet"),
      filter: { requiredRole: [ROLES.CREATOR] },
    },
    [AppointmentsTabNameEnum.MY_UPCOMING]: {
      name: AppointmentsTabNameEnum.MY_UPCOMING,
      title: $t("Upcoming"),
      getData: user => ({
        consumerId: user.id,
        status: [AppointmentStatus.APPROVED, AppointmentStatus.REJECTED, AppointmentStatus.CANCELLED],
        endTimeFrom: new Date().toISOString(),
      }),
      to: { name: "appointments", query: { tab: "myUpcoming" } },
      emptyText: $t("No appointments yet"),
      filter: { forbiddenRole: [ROLES.CREATOR] },
    },
    [AppointmentsTabNameEnum.PENDING]: {
      name: AppointmentsTabNameEnum.PENDING,
      title: $t("Pending"),
      getData: user => ({ consumerId: user.id, status: [AppointmentStatus.NEW] }),
      to: { name: "appointments", query: { tab: "pending" } },
      emptyText: $t("No requests yet"),
      filter: { forbiddenRole: [ROLES.CREATOR] },
    },
  };
});

export const appointmentTypeNames = {
  [AppointmentTypeKind.MESSAGING]: $t("Messaging"),
  [AppointmentTypeKind.VIDEO_CALLS]: $t("Video call"),
  [AppointmentTypeKind.AUDIO_CALLS]: $t("Audio call"),
  [AppointmentTypeKind.TOUR_GUIDE]: $t("Offline meeting"),
};
